import { call, put, select } from "redux-saga/effects";
import { ActionCreator, IAction } from "reduxsauce";
import { api } from "../dependencies";
import {
  analyticsAccountsPostSuccessResponseValueToAnalyticsAccountData,
  IAnalyticsAccountData,
} from "../parsers/users";
import { SagaAction } from "../sagas/types";
import * as selectors from "../selectors/selectors";
import { SagaFunction } from "./types";

export interface IFetchAllUsersForClassFurtherActions {
  onSuccess: ActionCreator;
  onFailure: ActionCreator;
}

export const fetchAllUsersForClass: (
  furtherActions: IFetchAllUsersForClassFurtherActions
) => SagaFunction = furtherActions =>
  function* _fetchAllAllUsersForClass(action: IAction): SagaAction {
    const accountId = yield select(selectors.accountId);
    const [usersError, usersResponse] = yield call(
      api.users.getAllForClass,
      accountId,
      action.courseId,
      action.classId
    );
    if (usersError) {
      yield put(furtherActions.onFailure({ message: "Failed to fetch users." }));
    } else {
      const usersData: [[string, string]] = usersResponse.data;
      const users: IAnalyticsAccountData[] = [];
      for (const userData of usersData) {
        const user = yield call(analyticsAccountsPostSuccessResponseValueToAnalyticsAccountData, userData);
        users.push(user);
      }
      yield put(furtherActions.onSuccess(users));
    }
  };

export interface IFetchAllUsersForScormPackageFurtherActions {
  onSuccess: ActionCreator;
  onFailure: ActionCreator;
}

export const fetchAllUsersForScormPackage: (
  furtherActions: IFetchAllUsersForScormPackageFurtherActions
) => SagaFunction = furtherActions =>
  function* _fetchAllAllUsersForScormPackage(action: IAction): SagaAction {
    const accountId = yield select(selectors.accountId);
    const [usersError, usersResponse] = yield call(
      api.users.getAllForScormPackage,
      accountId,
      action.courseId,
      action.scormPackageId
    );
    if (usersError) {
      yield put(furtherActions.onFailure({ message: "Failed to fetch users." }));
    } else {
      const usersData: [[string, string]] = usersResponse.data;
      const users: IAnalyticsAccountData[] = [];
      for (const userData of usersData) {
        const user = analyticsAccountsPostSuccessResponseValueToAnalyticsAccountData(userData);
        users.push(user);
      }
      yield put(furtherActions.onSuccess(users));
    }
  };
